import { create } from 'zustand';
import { EntityName } from 'shared/domain/entityName';
import type { UserModel } from 'shared/domain/user/types/model';
import { userClient } from 'shared/domain/user/userClient';
import { createSelectors, StoreName, withDevtools } from '../config';
import { createEntityCollectionActions, sendChangeWithoutWaiting } from '../entityCollection';
import { createDataActions, createInitialData } from '../types';
import type { ProjectUsersStore } from './types';

/** Users of the selected project, loaded and kept current through `userClient`. */
const useProjectUsersStoreBase = create<ProjectUsersStore>()(
  withDevtools(
    (set, get) => ({
      data: createInitialData<UserModel>(),

      actions: {
        ...createDataActions<UserModel, ProjectUsersStore>(set),
        ...createEntityCollectionActions({ client: userClient, entityName: EntityName.users }, () => get().actions),

        refresh: () => {
          get().actions.setLoading(true);
          userClient.sync();
        },
        revokeAccess: (userEditModel) =>
          sendChangeWithoutWaiting("revoking a user's access", () => userClient.edit(userEditModel)),
        remove: (userDeleteModel) =>
          sendChangeWithoutWaiting('removing a user', () => userClient.remove(userDeleteModel)),
      },
    }),
    StoreName.ProjectUsers
  )
);

export const useProjectUsersStore = createSelectors(useProjectUsersStoreBase);

export const getProjectUsersStoreState = (): ProjectUsersStore => useProjectUsersStore.getState();
